// extracted by mini-css-extract-plugin
module.exports = {"root":"u-flowable-email_edit_1b9Va53F"};